"use client";

import { NuqsAdapter } from "nuqs/adapters/next/app";
import { NextIntlClientProvider } from "next-intl";
import type { getMessages } from "next-intl/server";
import type { AppLocale } from "@/i18n/routing";

export function Providers({
  children,
  messages,
  locale,
}: {
  children: React.ReactNode;
  messages: Awaited<ReturnType<typeof getMessages>>;
  locale: AppLocale;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="Europe/Stockholm">
      <NuqsAdapter>{children}</NuqsAdapter>
    </NextIntlClientProvider>
  );
}
